var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.382 15.384-4.748 4.748a1.25 1.25 0 1 1-1.768-1.767l4.748-4.749L4.727 9.73a.72.72 0 0 1 .51-1.229h6.261l3-3V3.69a.7.7 0 0 1 1.195-.495l5.11 5.11a.7.7 0 0 1-.495 1.195h-1.81l-3 3v6.262a.72.72 0 0 1-1.229.509l-3.887-3.887z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin24);
export default __webpack_public_path__ + "static/media/pin_24.cf717d34.svg";
export { ForwardRef as ReactComponent };